'use strict';
import modules from '../helpers/modules';
/**
 * Disable the event call.
 */
export function _disableEvent(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

export function _setProgressbarPosition(event, slick, currentSlide, nextSlide) {
    let _ele = $(event.currentTarget).parents('.product-tile__packshots'),
        _sliderProgress = _ele.find('.swiper-scrollbar-drag'),
        _imgLength = _ele.find('.product-tile__packshots-img').length,
        _sliderProgressWidth = 100 / _imgLength,
        _sliderProgressLeft = _sliderProgressWidth * nextSlide,
        _getScreenDirection = $(event.currentTarget).parents('html').attr('dir');

    _sliderProgress.width(_sliderProgressWidth + '%');
    if (_getScreenDirection == 'rtl') {
        _sliderProgress.css({ marginRight: _sliderProgressLeft + '%' });
    } else {
        _sliderProgress.css({ marginLeft: _sliderProgressLeft + '%' });
    }
}

export function _setProgressbarPositionOnLoad(productTile) {
    let _ele = $(productTile),
        _imgLength = _ele.find('.product-tile__packshots-img').length,
        _sliderProgress = _ele.find('.swiper-scrollbar-drag'),
        _sliderProgressWidth = 100 / _imgLength;

    if (_imgLength > 1) {
        _sliderProgress.width(_sliderProgressWidth + '%');
    } else {
        _sliderProgress.addClass('hidden');
    }
}

export function productPackshotInit() {
    let allButtons = document.querySelectorAll('.slick-arrow'),
        allProductTiles = document.querySelectorAll('[data-product-packshots]');

    [].forEach.call(allProductTiles, function(_ProductTile) {
        _setProgressbarPositionOnLoad(_ProductTile);
    });

    [].forEach.call(allButtons, function(currentBtn) {
        currentBtn.addEventListener('click', function(event) {
            let pid = $(event.currentTarget).parents('.product-tile__packshots').attr('data-pid');
            _disableEvent(event);
            modules.tracking.init(null, {
                trackEvent: 'productPackShots',
                trackObject: {
                    asyncParams: {
                        'pid': pid
                    }
                }
            });
        })
    });

    $('.product-tile__packshots-slide').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        _setProgressbarPosition(event, slick, currentSlide, nextSlide);
    });
}
